import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useStyleFormInscript = makeStyles((theme) =>
  createStyles({
    root: {
      width: "98%",
      backgroundColor: theme.palette.background.paper,
      height: "auto",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      // maxHeight: 'calc(100vh - 100px)',
      overflowY: "auto",
      overflowX: "hidden",
      padding: "10px 0px 10px 0px",
    },
    root2: {
      width: "auto",
      backgroundColor: theme.palette.background.paper,
      height: "auto",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      overflowY: "visible",
      overflowX: "visible",
      padding: "0px",
    },
    inputsForm: {
      margin: "8px 0",
      [theme.breakpoints.down("sm")]: {
        //'sm' correspond à une largeur d'écran inférieure ou égale à 600px
        margin: "8px 0",
      },
    },
  })
);
